// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"7a45bfa6","453":"127ed222","457":"d528b079","551":"c35c75ef","617":"191c11d1","828":"8fe65206"}[chunkId] + ".chunk.js";
};